import { useAuth0 } from "@auth0/auth0-react";
import { ContentBlock } from "@pepperstone/pepper-ui-kit";
import { useEffect } from "react";

export const ContainerLogin = () => {
  const auth0 = useAuth0();

  // navigate away from the Login page if already authenticated
  useEffect(() => {
    (async () => {
      console.log("ContainerLogin authenticated", {
        isAuthenticated: auth0.isAuthenticated,
        isLoading: auth0.isLoading,
      });

      try {
        if (auth0.isAuthenticated && !auth0.isLoading) {
          const token = await auth0.getAccessTokenSilently();
          console.log("User is authenticated", { token });
          window.location.href = "/cashier-app";
        } else {
          console.log("User is not authenticated", {
            isAuthenticated: auth0.isAuthenticated,
            isLoading: auth0.isLoading,
          });
        }
      } catch (error) {
        console.error("Error checking authentication:", error);
        await auth0.loginWithRedirect();
      }
    })();
  }, [auth0]);

  if (!auth0 || auth0.isLoading)
    return (
      <ContentBlock
        title="PNX Cashier Dev Page"
        content="Loading Cashier application..."
      />
    );

  if (auth0.isAuthenticated) {
    return (
      <ContentBlock
        title="PNX Cashier Dev Page"
        content="Login successful. Redirecting to Cashier..."
      />
    );
  }

  return (
    <ContentBlock
      title="PNX Cashier Dev Page"
      buttonLabel="Login"
      buttonOnClick={() => auth0.loginWithRedirect()}
    />
  );
};
